var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 9,
    height: 9
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 9,
    height: 9,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z",
    fill: "#FFC0C0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 9,
    height: 9
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 9,
    height: 9,
    fill: "#FFC0C0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z",
    fill: "#C0C7FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 9,
    height: 9
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 9,
    height: 9,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z",
    fill: "#FFE7B6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 9,
    height: 9
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02944 13.9706 0 9 0V0C4.02944 0 0 4.02944 0 9V9C0 13.9706 4.02944 18 9 18V18C13.9706 18 18 13.9706 18 9V9Z",
    fill: "#B4FFEE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.d2cfca1ece798121b205dcf39c604e44.svg";
export { ForwardRef as ReactComponent };